export default "__VITE_ASSET__GYsWTql___"